var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoVehicleInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3418 19.7355H5.5L8.78941 12.5737C9.57575 10.861 11.1938 9.77783 12.9654 9.77783H28.8769C30.648 9.77783 32.266 10.861 33.0529 12.5737L36.3418 19.7355Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4828 32.889H4.11723C2.39552 32.889 1 31.6088 1 30.0292V23.3049C1 21.7253 2.39552 20.4446 4.11723 20.4446H37.4828C39.2045 20.4446 40.6 21.7253 40.6 23.3049V30.0292C40.6 31.6088 39.2045 32.889 37.4828 32.889Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39912 32.8889V35.7268C9.39912 37.3308 8.12367 38.6314 6.54954 38.6314C4.9754 38.6314 3.69995 37.3308 3.69995 35.7268V32.8889",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2114 32.8889V35.7268C38.2114 37.3308 36.9354 38.6314 35.3618 38.6314C33.7882 38.6314 32.5122 37.3308 32.5122 35.7268V32.8889",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73457 26.1582C9.73457 27.3501 8.78659 28.3164 7.61729 28.3164C6.44798 28.3164 5.5 27.3501 5.5 26.1582C5.5 24.9663 6.44798 24 7.61729 24C8.78659 24 9.73457 24.9663 9.73457 26.1582Z",
    fill: "#FFD4A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3415 26.1582C36.3415 27.3501 35.3935 28.3164 34.2242 28.3164C33.0549 28.3164 32.1069 27.3501 32.1069 26.1582C32.1069 24.9663 33.0549 24 34.2242 24C35.3935 24 36.3415 24.9663 36.3415 26.1582Z",
    fill: "#FFD4A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVehicleInfo);
export default __webpack_public_path__ + "static/media/ico_vehicle_info.5385e1efa724b55ec31fd9279cb41010.svg";
export { ForwardRef as ReactComponent };